import { Injectable, signal } from '@angular/core';
import { NodeType } from '@/new-transport/_shared/city-map/city/city-modal/participants-tab/participants-tab.model';

export interface ExpandedNodes {
	nodeId: number;
	nodeType: NodeType;
}

@Injectable({ providedIn: 'root' })
export class TreeExpandedNodesService {
	private readonly _expandedNodes = signal<ExpandedNodes[]>([]);

	nodeIncluded(id: number, nodeType: NodeType): boolean {
		return this._expandedNodes().some((node) => node.nodeId === id && node.nodeType === nodeType);
	}

	removeNode(id: number, nodeType: NodeType): void {
		this._expandedNodes.set(
			this._expandedNodes().filter((node) => node.nodeId !== id || node.nodeType !== nodeType),
		);
	}

	removeAllNodes(): void {
		this._expandedNodes.set([]);
	}

	addNode(id: number, nodeType: NodeType): void {
		if (this.nodeIncluded(id, nodeType)) {
			return;
		}

		this._expandedNodes.set([...this._expandedNodes(), { nodeId: id, nodeType }]);
	}
}
